export const jobList = [
  {
    id: 0,
    title: "Junior Frontend Developer",
    location: "phnom_penh",
    location_label: "Phnom Penh",
    slug: "junior-frontend-developer-0",
    code: "job-fe-000",
    department: "frontend",
    job_level: "junior",
  },
  {
    id: 1,
    title: "Frontend Developer",
    location: "ratanakiri",
    location_label: "Ratanakiri",
    slug: "frontend-developer-1",
    code: "job-fe-001",
    department: "frontend",
    job_level: "mid",
  },
  {
    id: 2,
    title: "Senior Frontend Developer",
    location: "poipet",
    location_label: "Poipet",
    slug: "senior-frontend-developer-2",
    code: "job-fe-002",
    department: "frontend",
    job_level: "senior",
  },
  {
    id: 3,
    title: "Junior Backend Developer",
    location: "phnom_penh",
    location_label: "Phnom Penh",
    slug: "junior-backend-developer-3",
    code: "job-be-003",
    department: "backend",
    job_level: "junior",
  },
  {
    id: 4,
    title: "Backend Developer",
    location: "ratanakiri",
    location_label: "Ratanakiri",
    slug: "backend-developer-4",
    code: "job-be-004",
    department: "backend",
    job_level: "mid",
  },
  {
    id: 5,
    title: "Senior Backend Developer",
    location: "poipet",
    location_label: "Poipet",
    slug: "senior-backend-developer-5",
    code: "job-be-005",
    department: "backend",
    job_level: "senior",
  },
  {
    id: 6,
    title: "Junior UI/UX Designer",
    location: "phnom_penh",
    location_label: "Phnom Penh",
    slug: "junior-ui-ux-designer-6",
    code: "job-des-006",
    department: "designer",
    job_level: "junior",
  },
  {
    id: 7,
    title: "UI/UX Designer",
    location: "ratanakiri",
    location_label: "Ratanakiri",
    slug: "ui-ux-designer-7",
    code: "job-des-007",
    department: "designer",
    job_level: "mid",
  },
  {
    id: 8,
    title: "Senior UI/UX Designer",
    location: "poipet",
    location_label: "Poipet",
    slug: "senior-ui-ux-designer-8",
    code: "job-des-008",
    department: "designer",
    job_level: "senior",
  },
  {
    id: 9,
    title: "Junior Product Designer",
    location: "phnom_penh",
    location_label: "Phnom Penh",
    slug: "junior-product-designer-9",
    code: "job-des-009",
    department: "designer",
    job_level: "junior",
  },
  {
    id: 10,
    title: "Product Designer",
    location: "ratanakiri",
    location_label: "Ratanakiri",
    slug: "product-designer-10",
    code: "job-des-010",
    department: "designer",
    job_level: "mid",
  },
  {
    id: 11,
    title: "Senior Product Designer",
    location: "poipet",
    location_label: "Poipet",
    slug: "senior-product-designer-11",
    code: "job-des-011",
    department: "designer",
    job_level: "senior",
  },
  {
    id: 12,
    title: "Junior Frontend Developer",
    location: "phnom_penh",
    location_label: "Phnom Penh",
    slug: "junior-frontend-developer-12",
    code: "job-fe-012",
    department: "frontend",
    job_level: "junior",
  },
  {
    id: 13,
    title: "Frontend Developer",
    location: "ratanakiri",
    location_label: "Ratanakiri",
    slug: "frontend-developer-13",
    code: "job-fe-013",
    department: "frontend",
    job_level: "mid",
  },
  {
    id: 14,
    title: "Senior Frontend Developer",
    location: "poipet",
    location_label: "Poipet",
    slug: "senior-frontend-developer-14",
    code: "job-fe-014",
    department: "frontend",
    job_level: "senior",
  },
  {
    id: 15,
    title: "Junior Backend Developer",
    location: "phnom_penh",
    location_label: "Phnom Penh",
    slug: "junior-backend-developer-15",
    code: "job-be-015",
    department: "backend",
    job_level: "junior",
  },
  {
    id: 16,
    title: "Backend Developer",
    location: "ratanakiri",
    location_label: "Ratanakiri",
    slug: "backend-developer-16",
    code: "job-be-016",
    department: "backend",
    job_level: "mid",
  },
  {
    id: 17,
    title: "Senior Backend Developer",
    location: "poipet",
    location_label: "Poipet",
    slug: "senior-backend-developer-17",
    code: "job-be-017",
    department: "backend",
    job_level: "senior",
  },
  {
    id: 18,
    title: "Junior UI/UX Designer",
    location: "phnom_penh",
    location_label: "Phnom Penh",
    slug: "junior-ui-ux-designer-18",
    code: "job-des-018",
    department: "designer",
    job_level: "junior",
  },
  {
    id: 19,
    title: "UI/UX Designer",
    location: "ratanakiri",
    location_label: "Ratanakiri",
    slug: "ui-ux-designer-19",
    code: "job-des-019",
    department: "designer",
    job_level: "mid",
  },
  {
    id: 20,
    title: "Senior UI/UX Designer",
    location: "poipet",
    location_label: "Poipet",
    slug: "senior-ui-ux-designer-20",
    code: "job-des-020",
    department: "designer",
    job_level: "senior",
  },
  {
    id: 21,
    title: "Junior Frontend Developer",
    location: "phnom_penh",
    location_label: "Phnom Penh",
    slug: "junior-frontend-developer-21",
    code: "job-fe-021",
    department: "frontend",
    job_level: "junior",
  },
  {
    id: 22,
    title: "Frontend Developer",
    location: "ratanakiri",
    location_label: "Ratanakiri",
    slug: "frontend-developer-22",
    code: "job-fe-022",
    department: "frontend",
    job_level: "mid",
  },
  {
    id: 23,
    title: "Senior Frontend Developer",
    location: "poipet",
    location_label: "Poipet",
    slug: "senior-frontend-developer-23",
    code: "job-fe-023",
    department: "frontend",
    job_level: "senior",
  },
  {
    id: 24,
    title: "Junior Backend Developer",
    location: "phnom_penh",
    location_label: "Phnom Penh",
    slug: "junior-backend-developer-24",
    code: "job-be-024",
    department: "backend",
    job_level: "junior",
  },
  {
    id: 25,
    title: "Backend Developer",
    location: "ratanakiri",
    location_label: "Ratanakiri",
    slug: "backend-developer-25",
    code: "job-be-025",
    department: "backend",
    job_level: "mid",
  },
  {
    id: 26,
    title: "Senior Backend Developer",
    location: "poipet",
    location_label: "Poipet",
    slug: "senior-backend-developer-26",
    code: "job-be-026",
    department: "backend",
    job_level: "senior",
  },
  {
    id: 27,
    title: "Junior Product Designer",
    location: "phnom_penh",
    location_label: "Phnom Penh",
    slug: "junior-product-designer-27",
    code: "job-des-027",
    department: "designer",
    job_level: "junior",
  },
  {
    id: 28,
    title: "Product Designer",
    location: "ratanakiri",
    location_label: "Ratanakiri",
    slug: "product-designer-28",
    code: "job-des-028",
    department: "designer",
    job_level: "mid",
  },
  {
    id: 29,
    title: "Senior Product Designer",
    location: "poipet",
    location_label: "Poipet",
    slug: "senior-product-designer-29",
    code: "job-des-029",
    department: "designer",
    job_level: "senior",
  },
  {
    id: 30,
    title: "Junior Frontend Developer",
    location: "phnom_penh",
    location_label: "Phnom Penh",
    slug: "junior-frontend-developer-30",
    code: "job-fe-030",
    department: "frontend",
    job_level: "junior",
  },
  {
    id: 31,
    title: "Frontend Developer",
    location: "ratanakiri",
    location_label: "Ratanakiri",
    slug: "frontend-developer-31",
    code: "job-fe-031",
    department: "frontend",
    job_level: "mid",
  },
  {
    id: 32,
    title: "Senior Frontend Developer",
    location: "poipet",
    location_label: "Poipet",
    slug: "senior-frontend-developer-32",
    code: "job-fe-032",
    department: "frontend",
    job_level: "senior",
  },
  {
    id: 33,
    title: "Junior Backend Developer",
    location: "phnom_penh",
    location_label: "Phnom Penh",
    slug: "junior-backend-developer-33",
    code: "job-be-033",
    department: "backend",
    job_level: "junior",
  },
  {
    id: 34,
    title: "Backend Developer",
    location: "ratanakiri",
    location_label: "Ratanakiri",
    slug: "backend-developer-34",
    code: "job-be-034",
    department: "backend",
    job_level: "mid",
  },
  {
    id: 35,
    title: "Senior Backend Developer",
    location: "poipet",
    location_label: "Poipet",
    slug: "senior-backend-developer-35",
    code: "job-be-035",
    department: "backend",
    job_level: "senior",
  },
  {
    id: 36,
    title: "Junior UI/UX Designer",
    location: "phnom_penh",
    location_label: "Phnom Penh",
    slug: "junior-ui-ux-designer-36",
    code: "job-des-036",
    department: "designer",
    job_level: "junior",
  },
  {
    id: 37,
    title: "UI/UX Designer",
    location: "ratanakiri",
    location_label: "Ratanakiri",
    slug: "ui-ux-designer-37",
    code: "job-des-037",
    department: "designer",
    job_level: "mid",
  },
  {
    id: 38,
    title: "Senior UI/UX Designer",
    location: "poipet",
    location_label: "Poipet",
    slug: "senior-ui-ux-designer-38",
    code: "job-des-038",
    department: "designer",
    job_level: "senior",
  },
  {
    id: 39,
    title: "Junior Frontend Developer",
    location: "phnom_penh",
    location_label: "Phnom Penh",
    slug: "junior-frontend-developer-39",
    code: "job-fe-039",
    department: "frontend",
    job_level: "junior",
  },
  {
    id: 40,
    title: "Frontend Developer",
    location: "ratanakiri",
    location_label: "Ratanakiri",
    slug: "frontend-developer-40",
    code: "job-fe-040",
    department: "frontend",
    job_level: "mid",
  },
  {
    id: 41,
    title: "Senior Frontend Developer",
    location: "poipet",
    location_label: "Poipet",
    slug: "senior-frontend-developer-41",
    code: "job-fe-041",
    department: "frontend",
    job_level: "senior",
  },
  {
    id: 42,
    title: "Junior Backend Developer",
    location: "phnom_penh",
    location_label: "Phnom Penh",
    slug: "junior-backend-developer-42",
    code: "job-be-042",
    department: "backend",
    job_level: "junior",
  },
  {
    id: 43,
    title: "Backend Developer",
    location: "ratanakiri",
    location_label: "Ratanakiri",
    slug: "backend-developer-43",
    code: "job-be-043",
    department: "backend",
    job_level: "mid",
  },
  {
    id: 44,
    title: "Senior Backend Developer",
    location: "poipet",
    location_label: "Poipet",
    slug: "senior-backend-developer-44",
    code: "job-be-044",
    department: "backend",
    job_level: "senior",
  },
  {
    id: 45,
    title: "Junior Product Designer",
    location: "phnom_penh",
    location_label: "Phnom Penh",
    slug: "junior-product-designer-45",
    code: "job-des-045",
    department: "designer",
    job_level: "junior",
  },
  {
    id: 46,
    title: "Product Designer",
    location: "ratanakiri",
    location_label: "Ratanakiri",
    slug: "product-designer-46",
    code: "job-des-046",
    department: "designer",
    job_level: "mid",
  },
  {
    id: 47,
    title: "Senior Product Designer",
    location: "poipet",
    location_label: "Poipet",
    slug: "senior-product-designer-47",
    code: "job-des-047",
    department: "designer",
    job_level: "senior",
  },
  {
    id: 48,
    title: "Junior Frontend Developer",
    location: "phnom_penh",
    location_label: "Phnom Penh",
    slug: "junior-frontend-developer-48",
    code: "job-fe-048",
    department: "frontend",
    job_level: "junior",
  },
  {
    id: 49,
    title: "Frontend Developer",
    location: "ratanakiri",
    location_label: "Ratanakiri",
    slug: "frontend-developer-49",
    code: "job-fe-049",
    department: "frontend",
    job_level: "mid",
  },
]


export const menuNavData = [
  {
    id: 1,
    title: 'Department',
    field: 'department',
    filter: [
      { uuid: 'wkrhwjehrh-12312313-12312312-safdfasdf1', slug: 'all', filter_title: 'All Department' },
      { uuid: 'wkrhwjehrh-12312313-12312312-safdfasdf2', slug: 'frontend', filter_title: 'Frontend' },
      { uuid: 'wkrhwjehrh-12312313-12312312-safdfasdf3', slug: 'backend', filter_title: 'Backend' },
      { uuid: 'wkrhwjehrh-12312313-12312312-safdfasdf4', slug: 'designer', filter_title: 'Designer' },
    ],
  },
  {
    id: 2,
    title: 'Job Level',
    field: 'job_level',
    filter: [
      { uuid: 'wkrhwjehrh-12312313-12312312-safdfasdf1', slug: 'all', filter_title: 'All Levels' },
      { uuid: 'wkrhwjehrh-12312313-12312312-safdfasdf2', slug: 'junior', filter_title: 'Junior' },
      { uuid: 'wkrhwjehrh-12312313-12312312-safdfasdf3', slug: 'mid', filter_title: 'Mid' },
      { uuid: 'wkrhwjehrh-12312313-12312312-safdfasdf4', slug: 'senior', filter_title: 'Senior' },
    ],
  },
  {
    id: 3,
    title: 'Job Location',
    field: 'location',
    filter: [
      { uuid: 'wkrhwjehrh-12312313-12312312-safdfasdf1', slug: 'all', filter_title: 'All Locations' },
      { uuid: 'wkrhwjehrh-12312313-12312312-safdfasdf2', slug: 'phnom_penh', filter_title: 'Phnom Penh' },
      { uuid: 'wkrhwjehrh-12312313-12312312-safdfasdf3', slug: 'ratanakiri', filter_title: 'Ratanakiri' },
      { uuid: 'wkrhwjehrh-12312313-12312312-safdfasdf4', slug: 'poipet', filter_title: 'Poipet' },
    ],
  },
]

